<template>
  <div class="container">
    <div class="margin-top-40">
      <img src="../../../assets/image/ic_logo@2x.png" class="logo_img"/>
    </div>
    <div class="title_wrapper">
      <label class="title">
        {{ $t('signup_quiz.title') }}
      </label>
    </div>
    <div class="quiz_list">
      <div class="quiz_item">
        <div class="quiz">
          <a class="answer">
            <img src="../../../assets/image/ic_check_on@2x.png" class="img_check">
          </a>
          <label class="answer_text">asdfasd asdf asdf sadf</label>
        </div>
      </div>
    </div>
    <b-button class="signup_btn">
      <label class="signup_label">{{ $t('signup_quiz.apply_subscription') }}</label>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "SignupQuiz"
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/auth/SignupQuiz";
  .container{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .img_check {
    width: 15px;
    height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contents/auth/SignupQuiz.vue